export default __webpack_public_path__ + "static/media/phone.d4ac4ea1.svg";